module.exports = __webpack_public_path__ + "static/Sonyax44-c66574de193c64320c5cac7dceba6e5e.png";